import { VueAccordion, VueAccordionItem } from '@ui-common/vue-accordion';
import VueTooltip from '@ui-common/vue-tooltip';

export default {
	data() {
		return {
			detailsOpened: false
		};
	},
	props: {
		product: {
			required: true
		}
	},
	components: {
		VueAccordion,
		VueAccordionItem,
		VueTooltip
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	}
};
